import React from "react";

import { Tooltip } from "./Tooltip/Tooltip";

interface Props {
  text: string;
  limit?: number;
  position?: "top" | "top-end" | "bottom" | "bottom-end" | "left" | "bottom-right";
}

export const TruncatedTextTooltip = ({ text, limit = 50, position = "bottom" }: Props) => {
  if (text.length > limit) {
    return (
      <Tooltip position={position} content={text}>
        <span>{text.slice(0, limit)}...</span>
      </Tooltip>
    );
  }

  return <>{text}</>;
};
